<template>
    <div class="row websdk-instructions" :class="{ isPopup: isPopup }">
        <div class="photo-tips">
            <div class="page-one">
                <h1 class="container__standard-header">
                    {{ $t(`${TRANSLATION_KEY}.howTakePictureHeader`) }}
                </h1>
                <div class="photo-tips__container">
                    <div ref="swiper" class="swiper-container">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide">
                                <h4 class="slide-title">
                                    {{ $t(`${TRANSLATION_KEY}.goodExample`) }}
                                </h4>
                                <img
                                    src="@/assets/upload-instructions/good.png"
                                    alt="ok"
                                    class="instructions__example"
                                />
                                <p class="slide-text">
                                    {{
                                        $t(`${TRANSLATION_KEY}.devicePosition`)
                                    }}
                                </p>
                                <p class="slide-text">
                                    {{
                                        $t(`${TRANSLATION_KEY}.fillEntireFrame`)
                                    }}
                                </p>
                            </div>
                            <div class="swiper-slide swiper-slide--bad">
                                <h4 class="slide-title">
                                    {{ $t(`${TRANSLATION_KEY}.badExample`) }}
                                </h4>
                                <img
                                    src="@/assets/upload-instructions/bad1.png"
                                    alt="ok"
                                    class="instructions__example"
                                />
                                <p class="slide-text">
                                    {{
                                        $t(
                                            `${TRANSLATION_KEY}.avoidHorizontalDocument`
                                        )
                                    }}
                                </p>
                                <p class="slide-text">
                                    {{ $t(`${TRANSLATION_KEY}.avoidBlurry`) }}
                                </p>
                            </div>
                            <div class="swiper-slide swiper-slide--bad">
                                <h4 class="slide-title">
                                    {{ $t(`${TRANSLATION_KEY}.badExample`) }}
                                </h4>
                                <img
                                    src="@/assets/upload-instructions/bad2.svg"
                                    alt="ok"
                                    class="instructions__example"
                                />
                                <p class="slide-text">
                                    {{
                                        $t(
                                            `${TRANSLATION_KEY}.avoidHorizontalDevice`
                                        )
                                    }}
                                </p>
                                <p class="slide-text">
                                    {{
                                        $t(
                                            `${TRANSLATION_KEY}.autoCaptureOnTitle`
                                        )
                                    }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="photo-tips__bottom">
                <p>
                    {{ $t(`${TRANSLATION_KEY}.TipsForQuality`) }}
                </p>
                <div class="photo-tips__grid">
                    <div class="photo-tips__item">
                        <img
                            src="@/assets/upload-instructions/tip1.png"
                            alt=""
                        />
                        <div>
                            <h5>
                                {{
                                    $t(`${TRANSLATION_KEY}.autoCaptureOnTitle`)
                                }}
                            </h5>
                            <p>
                                {{ $t(`${TRANSLATION_KEY}.autoCaptureOnText`) }}
                            </p>
                        </div>
                    </div>
                    <div class="photo-tips__item">
                        <img
                            src="@/assets/upload-instructions/tip2.png"
                            alt=""
                        />
                        <div>
                            <h5>
                                {{
                                    $t(`${TRANSLATION_KEY}.doNotCoverDataTitle`)
                                }}
                            </h5>
                            <p>
                                {{
                                    $t(`${TRANSLATION_KEY}.doNotCoverDataText`)
                                }}
                            </p>
                        </div>
                    </div>
                </div>
                <p v-if="!isPopup" class="text-center">
                    {{ $t(`${TRANSLATION_KEY}.readyToTakePhoto`) }}
                </p>
                <div
                    class="row row--navigation-btn d-flex justify-center pb-70"
                >
                    <div
                        v-if="!isPopup"
                        class="row row--navigation-btn d-flex justify-center"
                    >
                        <button
                            type="button"
                            class="button button-biger button--submit"
                            @click="handleHowToTakePictureInfo()"
                        >
                            {{ $t(`${TRANSLATION_KEY}.LetsTakePicture`) }}
                        </button>
                    </div>
                    <button
                        v-else
                        type="button"
                        class="button button-biger button--submit photo-instructions-button"
                        @click="handleClosePopup"
                    >
                        {{ $t(`${TRANSLATION_KEY}.Close`) }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
import { useStore } from 'vuex';
import { onMounted, ref } from 'vue';

export default defineComponent({
    name: 'HowToTakePicture',
    components: {},

    props: {
        isPopup: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['childEvent'],
    setup(props, { emit }) {
        const store = useStore();

        const swiper = ref<HTMLElement | null>(null);

        const TRANSLATION_KEY = 'steps.HowToTakePicture';

        const handleHowToTakePictureInfo = () => {
            store.state.isLocked = 'active';
            setTimeout(() => {
                store.state.isLocked = '';
                emit('childEvent');
            }, 1000);
        };

        const handleClosePopup = () => {
            store.state.showInstructionPopup = false;
            window.scrollTo(0, 0);
        };

        onMounted(() => {
            setTimeout(() => {
                if (swiper.value) {
                    new Swiper(swiper.value, {
                        slidesPerView: 2.2,
                        spaceBetween: 10,
                        pagination: {
                            el: '.swiper-pagination',
                        },
                    });
                }
            }, 0);
        });

        return {
            TRANSLATION_KEY,
            handleHowToTakePictureInfo,
            swiper,
            handleClosePopup,
            isPopup: props.isPopup,
        };
    },
});
</script>

<style lang="scss" scoped>
.websdk-instructions {
    margin: 0 auto;
    padding: 30px 0 30px 20px;
    background: #ffffff;
    max-width: 100%;
    height: 100vh;
    &.isPopup {
        position: fixed;
        width: 100%;
        border-radius: 0;
        z-index: 11;
        height: 100vh;
        top: 0;
        left: 0;
        overflow-y: auto;
    }
    h1 {
        padding-right: 20px;
    }

    .photo-instructions-button:focus-visible {
        outline: 2px solid #192241;
        outline-offset: 2px;
    }

    .isPopup {
        position: fixed;
        width: 100%;
        border-radius: 0;
        z-index: 11;
        height: 100vh;
        top: 0;
    }

    .photo-tips {
        max-width: 420px;
        margin: 0 auto;

        &__bottom {
            padding-right: 20px;
            margin-top: 30px;

            p {
                margin: 0;
            }

            .text-center {
                text-align: center;
                font-size: 16px;
                line-height: 22px;
                font-weight: 600;
                width: 100%;
                max-width: 260px;
                margin: 30px auto 0;
            }
        }

        &__item {
            display: grid;
            grid-template-columns: 56px auto;
            gap: 10px;
            align-items: center;
            margin-top: 12px;

            &:not(:last-of-type) {
                margin-bottom: 20px;
            }

            h5 {
                font-size: 14px;
                line-height: 21px;
                font-weight: 700;
            }

            p {
                font-size: 13px;
                line-height: 19px;
                font-weight: 400;
            }
        }
    }

    .button {
        margin-bottom: 0;
    }

    .button--submit {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 20px;
    }

    .slide-title {
        font-size: 14px;
        font-weight: 600;
        text-align: center;
    }

    .swiper-slide {
        background: #eefbf2;
        padding: 10px 8px;
        height: auto;

        p {
            margin-bottom: 0;
            text-align: center;
        }

        * {
            color: #00884e;
        }

        img {
            display: block;
            margin: 0 auto;
        }
    }

    .swiper-slide--bad {
        background: #fee6e9;

        * {
            color: #e41f37;
        }
    }

    .pb-70 {
        padding-bottom: 70px;
    }
}
</style>
